import { createReducer } from 'store/createReducer';
import { ConservatoryAddonsModel } from 'models/ConservatoryAddonsModel';
import {
  GUIDE_ADDONS_DATA_LOADING,
  GUIDE_ADDONS_DATA_LOADED,
  GUIDE_ADDONS_SELECT_PRODUCT,
  ConservatoryAddonsSelectAction,
  ConservatoryAddonsAction
} from './actions';
import { GUIDE_MAKE_PRODUCT_SELECTED } from '../Make/actions';
import {
  GUIDE_SIZE_TOGGLE_CORNERS,
  GUIDE_SIZE_SELECT_WIDTH,
  GUIDE_SIZE_SELECT_DEPTH
} from '../Size/actions';
import { ConservatoryStepValid } from 'models/ConservatoryStepValid';

const resetState = (state: ConservatoryAddonsModel): ConservatoryAddonsModel => {
  return {
    ...state,
    products: []
  };
};

const addonsReducer = {
  [GUIDE_SIZE_TOGGLE_CORNERS]: (state: ConservatoryAddonsModel) => {
    return resetState(state);
  },
  [GUIDE_SIZE_SELECT_WIDTH]: (state: ConservatoryAddonsModel) => {
    return resetState(state);
  },
  [GUIDE_SIZE_SELECT_DEPTH]: (state: ConservatoryAddonsModel) => {
    return resetState(state);
  },
  [GUIDE_MAKE_PRODUCT_SELECTED]: (state: ConservatoryAddonsModel) => {
    return resetState(state);
  },

  [GUIDE_ADDONS_SELECT_PRODUCT]: (
    state: ConservatoryAddonsModel,
    action: ConservatoryAddonsSelectAction
  ) => {
    return {
      ...state,
      products: state.products.map(product => {
        let selected = product.selected;
        if (product.productId === action.productId) {
          selected = product.selected ? false : true;
        }

        return {
          ...product,
          selected
        };
      })
    };
  },

  [GUIDE_ADDONS_DATA_LOADED]: (
    state: ConservatoryAddonsModel,
    action: ConservatoryAddonsAction
  ) => {
    return {
      ...state,
      products: action.products,
      dataLoading: false
    };
  },
  [GUIDE_ADDONS_DATA_LOADING]: (state: ConservatoryAddonsModel) => {
    return {
      ...state,
      dataLoading: true
    };
  }
};

export default createReducer(
  {
    dataLoading: false,
    isValid: ConservatoryStepValid.Unknown,
    products: []
  },
  addonsReducer
);
